module.exports = __webpack_public_path__ + "IntellectualCropped-55fed4a2bbcef4d864b327a85bb7725e.png";